import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import Barcodes from '../../components/Barcode';
import {BarcodeContainer} from'../../components/productosComponents';
class BarcodeSection extends PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <BarcodeContainer>
      <h4>CO.CO KIDS RE-STORE</h4>   
      <Barcodes src={this.props.UserId +"."+ this.props.codigoProducto} />
      <div style={{ fontSize: '12px' }}>{this.props.descripcion}</div>
      </BarcodeContainer >
    );
  }
}

BarcodeSection.propTypes = {
  codigoProducto: PropTypes.string,
  descripcion: PropTypes.string,
  UserId: PropTypes.string,
};

export default BarcodeSection;
